module.exports = __webpack_public_path__ + "static/GorditaBlack-BlackItalic-362eb4678290924320d229b42b325884.otf";